import { Box, Card } from "@mui/material";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d22358.412532829894!2d-73.50904244027116!3d45.53419858077724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91b99f0b1a597%3A0xdd72018ccb0a59d9!2sEsdl%20School%20Shotokan%20Dojo%20Longueuil!5e0!3m2!1sen!2sca!4v1679590983390!5m2!1sen!2sca";

type MapEmbedProps = {
  maxWidth?: number;
  /** A CSS aspect-ratio, either flat or keyed by breakpoint. */
  ratio?: string | { [breakpoint: string]: string };
  rounded?: boolean;
  filter?: string;
};

export function MapEmbed({
  maxWidth = 560,
  ratio = { xs: "4 / 3", md: "16 / 9" },
  rounded = true,
  filter,
}: MapEmbedProps) {
  return (
    <Card
      elevation={rounded ? 3 : 0}
      sx={{
        width: "100%",
        maxWidth,
        borderRadius: rounded ? 3 : 0,
        overflow: "hidden",
        position: "relative",
        aspectRatio: ratio,
      }}
    >
      <Box
        component="iframe"
        title="Localisation Volt BJJ"
        src={MAP_SRC}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen={false}
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          border: 0,
          filter: filter || "none",
        }}
      />
    </Card>
  );
}
